 <!-- SECCIÓN HOME -->
    <section id="home">
        <div class="container py-5">
            <div class="row align-items-center g-4">
                <div class="col-12 col-lg-6 text-center order-1 order-lg-1 slide-left">
                    <img src="https://www.unipay.cl/api/descargaArchivo/web-app-pancho-celular-app.png" class="img-fluid mx-auto d-block pancho-celular hover-lift" alt="Pancho celular App Unipay">
                </div>

                <div class="col-12 col-lg-6 text-center text-lg-start order-2 order-lg-2 mb-4 mb-lg-0 slide-right">
                    <h2 class="mb-4 fade-in delay-1">Elige inteligente.<br>Elige pagar con la<br class="d-none d-md-block"> nueva <b>App Unipay.</b></h2>
                    <p class="mb-4 text-roboto fade-in delay-2">
                        Con tu tarjeta Unipay, disfruta y aprovecha todos los<br class="d-none d-md-block">
                        beneficios y descuentos en nuestros supermercados.
                    </p>

                    <div class="logos-y-boton">
                        <img src="https://www.unipay.cl/api/descargaArchivo/web-app-logos-supermercado.png" alt="Supermercados Unimarc, Super 10 y Alvi" class="img-fluid mb-4 d-block mx-auto mx-lg-0 slide-up delay-3" style="max-width:300px">
                        <a (click)="downloadApp()"  class="btn btn-descarga pulse-soft slide-up delay-4">DESCARGA TU APP</a>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <!-- SECCIÓN CÓDIGO -->
    <section id="codigo" class="py-5 position-relative" style="background-color:#7033fc; overflow: visible;">
        <div class="container">
            <div class="row align-items-center g-5">
                <div class="col-12 col-md-4 text-center text-md-end order-2 order-md-1 slide-left delay-1">
                    <h3 class="mb-3 text-white">Código<br class="d-none d-md-block"> de compra</h3>
                    <p class="d-flex align-items-center justify-content-center justify-content-md-end gap-2 fw-semibold mb-3 text-white">
                        <img src="https://www.unipay.cl/api/descargaArchivo/web-app-numero-1.png" alt="1" width="28" height="28">
                        <span style="letter-spacing: 2px;">PAGA CON CÓDIGO</span>
                    </p>
                    <p class="mb-0 text-white text-roboto">
                        Ahora no sólo tienes tu huella<br class="d-none d-md-block">
                        para pagar, también podrás<br class="d-none d-md-block">
                        pagar presencial con tu Código<br class="d-none d-md-block">
                        de compras, en supermercados<br class="d-none d-md-block">
                        Unimarc, Alvi y Super 10.
                    </p>
                </div>

                <div class="col-12 col-md-4 text-center order-1 order-md-2 bounce-soft delay-2">
                    <img src="https://www.unipay.cl/api/descargaArchivo/web-app-celular-codigo.png" class="img-fluid mx-auto d-block celular-codigo hover-lift" alt="Celular App Unipay Código de Compra" style="max-width: 350px; margin-top: -90px; margin-bottom: -120px;">
                </div>

                <div class="col-12 col-md-4 text-center text-md-start ps-md-4 order-3 order-md-3">
                    <p class="d-flex align-items-center justify-content-center justify-content-md-start gap-2 fw-semibold mb-4 text-white slide-right delay-1">
                        <img src="https://www.unipay.cl/api/descargaArchivo/web-app-numero-2.png" alt="2" width="28" height="28">
                        <span style="letter-spacing: 2px;">SIGUE ESTOS PASOS<br class="d-none d-md-block">
                            PARA PAGAR:</span>
                    </p>

                    <div class="d-flex align-items-center justify-content-center justify-content-md-start gap-3 mb-3 ms-3 slide-up stagger-1">
                        <img src="https://www.unipay.cl/api/descargaArchivo/web-app-paso-1.png" alt="Paso 1" width="60" height="60" class="flex-shrink-0 pasos hover-scale">
                        <p class="mb-0 text-white text-start text-roboto">
                            Dicta tu rut en caja<br class="d-none d-md-block"> al momento de pagar
                        </p>
                    </div>

                    <div class="d-flex align-items-center justify-content-center justify-content-md-start gap-3 mb-3 ms-3 slide-up stagger-2">
                        <img src="https://www.unipay.cl/api/descargaArchivo/web-app-paso-2.png" alt="Paso 2" width="60" height="60" class="flex-shrink-0 pasos hover-scale">
                        <p class="mb-0 text-white text-start text-roboto">
                            Abre tu App Unipay<br class="d-none d-md-block"> en tu smartphone
                        </p>
                    </div>

                    <div class="d-flex align-items-center justify-content-center justify-content-md-start gap-3 mb-3 ms-3 slide-up stagger-3">
                        <img src="https://www.unipay.cl/api/descargaArchivo/web-app-paso-3.png" alt="Paso 3" width="60" height="60" class="flex-shrink-0 pasos hover-scale">
                        <p class="mb-0 text-white text-start text-roboto">
                            Dicta tu código de pago al<br class="d-none d-md-block"> momento de pagar ¡Y listo!
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <!-- SECCIÓN CUPO -->
    <section id="cupo" class="py-5">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-12 col-md-6 text-center slide-left delay-1">
                    <img src="https://www.unipay.cl/api/descargaArchivo/web-app-celular-cupo.png" class="img-fluid mx-auto d-block cupo-disponible hover-lift" alt="Celular App Unipay Cupo Disponible" style="max-width: 350px;">
                </div>

                <div class="col-12 col-md-6 text-center text-md-start slide-right delay-2">
                    <h3 class="mb-3 ms-md-5 text-purple" style="font-weight: 400;">
                        Cupo disponible y<br class="d-none d-md-block"> monto facturado
                    </h3>
                    <p class="mb-0 ms-md-5 text-roboto text-purple">
                        Podrás revisar más fácil tu<br class="d-none d-md-block">
                        cupo disponible al momento<br class="d-none d-md-block">
                        de realizar una compra y<br class="d-none d-md-block">
                        conocer tu monto facturado<br class="d-none d-md-block">
                        del mes en curso.
                    </p>
                </div>
            </div>
        </div>
    </section>

    <!-- SECCIÓN AVANCE -->
    <section id="super-avance" class="py-5" style="background-color:#00e7ce;">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-12 col-md-6 text-center text-md-end order-2 order-md-1 slide-left delay-1">
                    <h3 class="mb-3 me-md-5 text-purple" style="font-weight: 400;">
                        Avance y<br class="d-none d-md-block"> Súper Avance
                    </h3>
                    <p class="mb-0 me-md-5 text-roboto text-purple">
                        Obtén tu Avance o Súper Avance de<br class="d-none d-md-block">
                        manera rápida y 100% online. Recibe el<br class="d-none d-md-block">
                        dinero en tu cuenta bancaria.<br class="d-none d-md-block">
                        Una solución simple, segura y conveniente<br class="d-none d-md-block">
                        para tus necesidades financieras.
                    </p>
                </div>

                <div class="col-12 col-md-6 text-center order-1 order-md-2 slide-right delay-2">
                    <img src="https://www.unipay.cl/api/descargaArchivo/web-app-celular-avances.png" class="img-fluid mx-auto d-block super-avance hover-lift" alt="Celular App Unipay Avance y Super Avance" style="max-width: 450px;">
                </div>
            </div>
        </div>
    </section>

    <!-- FOOTER -->
    <footer class="py-4 bg-dark text-white">
        <div class="container">
            <div class="row mb-4 pt-5 pb-3">
                <div class="col-12">
                    <div class="d-flex justify-content-center gap-5 flex-wrap">
                        <div class="download-group text-center zoom-in delay-1">
                            <div class="qr-container mb-3 qr-hover">
                                <img src="https://www.unipay.cl/api/descargaArchivo/web-app-qr-app-store.png" width="200" class="qr-code" alt="QR App Store">
                            </div>
                            <a href="https://apps.apple.com/cl/app/unipay/id6742227439" target="_blank" rel="noopener noreferrer">
                                <img src="https://www.unipay.cl/api/descargaArchivo/web-app-app-store.png" height="60" alt="Descárgalo en el App Store" class="app-badge hover-scale">
                            </a>
                        </div>

                        <div class="download-group text-center zoom-in delay-2">
                            <div class="qr-container mb-3 qr-hover">
                                <img src="https://www.unipay.cl/api/descargaArchivo/web-app-qr-google-play.png" width="200" class="qr-code" alt="QR Google Play">
                            </div>
                            <a href="https://play.google.com/store/apps/details?id=lat.trust.android.unipay" target="_blank" rel="noopener noreferrer">
                                <img src="https://www.unipay.cl/api/descargaArchivo/web-app-google-play.png" height="60" alt="Disponible en Google Play" class="app-badge hover-scale">
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <hr class="border-secondary mb-4 fade-in delay-3">

            <div class="row">
                <div class="col-12">
                    <div class="d-flex flex-column flex-md-row justify-content-center align-items-center gap-3 fade-in delay-4">
                        <div class="d-flex align-items-center gap-3 order-1 order-md-1" style="width: 200px; justify-content: center;">
                            <a href="#" class="social-icon" target="_blank" rel="noopener noreferrer">
                                <img src="https://www.unipay.cl/api/descargaArchivo/web-app-icono-contacto.png" alt="Centro de Contacto">
                            </a>
                            <a href="https://api.whatsapp.com/send?phone=56958123297&text=Hola%20Unipay%20%F0%9F%98%80" class="social-icon" target="_blank" rel="noopener noreferrer">
                                <img src="https://www.unipay.cl/api/descargaArchivo/web-app-icono-whatsapp.png" alt="WhatsApp">
                            </a>
                            <a href="https://instagram.com/unipay_cl?igsh=MXEzaWQ0anRkYml4eQ==" class="social-icon" target="_blank" rel="noopener noreferrer">
                                <img src="https://www.unipay.cl/api/descargaArchivo/web-app-icono-instagram.png" alt="Instagram">
                            </a>
                        </div>

                        <hr class="d-block d-md-none border-secondary order-2 w-75 my-3">

                        <div class="d-none d-md-block order-md-2" style="margin: 0 2.5rem;">
                            <div class="vr" style="height: 50px; opacity: 0.3;"></div>
                        </div>

                        <div class="order-3 order-md-3" style="width: 200px; text-align: center;">
                            <a href="#" target="_blank" rel="noopener noreferrer">
                                <img src="https://www.unipay.cl/api/descargaArchivo/web-app-logo-unipay.png" height="40" alt="Unipay" class="logo-footer">
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </footer>